import React from "react";
import { cn } from "../lib/utils";
import { TestimonialCard, TestimonialAuthor } from "./ui/testimonial-card";
interface TestimonialsSectionProps {
  title: string;
  description: string;
  testimonials: Array<{
    author: TestimonialAuthor;
    text: string;
    href?: string;
  }>;
  className?: string;
}
export function TestimonialsSection({
  title,
  description,
  testimonials,
  className
}: TestimonialsSectionProps) {
  return <section className={cn("py-16 md:py-24 relative overflow-hidden", className)} data-id="element-97">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-4 text-center sm:gap-16 px-4 md:px-6" data-id="element-98">
        <div className="flex flex-col items-center gap-4 sm:gap-8" data-id="element-99">
          <h2 className="max-w-[720px] text-3xl font-semibold leading-tight sm:text-5xl sm:leading-tight text-white" data-id="element-100">
            {title}
          </h2>
          <p className="text-md max-w-[600px] font-medium text-white/60 sm:text-xl" data-id="element-101">
            {description}
          </p>
        </div>
        <div className="relative flex w-full flex-col items-center justify-center overflow-hidden" data-id="element-102">
          <div className="group flex overflow-hidden p-2 [--gap:1rem] [gap:var(--gap)] flex-row [--duration:40s]" data-id="element-103">
            <div className="flex shrink-0 justify-around [gap:var(--gap)] animate-marquee flex-row group-hover:[animation-play-state:paused]" data-id="element-104">
              {[...Array(4)].map((_, setIndex) => testimonials.map((testimonial, i) => <TestimonialCard key={`${setIndex}-${i}`} {...testimonial} data-id="element-105" />))}
            </div>
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 hidden w-1/3 bg-gradient-to-r from-neutral-950 sm:block" data-id="element-106" />
          <div className="pointer-events-none absolute inset-y-0 right-0 hidden w-1/3 bg-gradient-to-l from-neutral-950 sm:block" data-id="element-107" />
        </div>
      </div>
    </section>;
}